export default __webpack_public_path__ + "static/travel-back-in-time-visit-athens-parthenon-0c1e00c490d556b3e9283a2d5740a7c1.jpg";